import React, { Suspense, useEffect } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import ReactNotification from 'react-notifications-component';

import '../../node_modules/font-awesome/scss/font-awesome.scss';

import Loader from 'App/layout/Loader';

import ScrollToTop from 'App/layout/ScrollToTop';
import { SinglePageRoutes } from 'routes';
import AdminLayout from 'App/layout/AdminLayout';
import Core from 'containers/base/Core';

import { GOOGLE_AUTH_CLIENT_ID, resolveOemType } from 'lib/setting';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { keys, setCookie } from 'lib/util';
import TranslationProvider from 'components/base/language/TranslationProvider';
import { AppActions } from 'store/reduxActions';
import { logoMapper } from 'lib/mapper';

function App(props) {
  console.log('현재 URL', window.location.pathname);
  const Error = React.lazy(() => import('containers/error/Error'));
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const oemParam = queryParams.get('oem');

  const menu = SinglePageRoutes.map((route, index) => {
    return route.component ? (
      <Route
        key={index}
        path={route.path}
        exact={route.exact}
        name={route.name}
        render={props => <route.component {...props} />}
      />
    ) : null;
  });

  useEffect(() => {
    const isElectron = !!window.ipcRenderer;
    const oemValue = resolveOemType({
      isElectron,
      electronOemType: window.electronAPI?.oemType,
      queryOemType: oemParam,
      hostname: window.location.hostname,
    });
    // 쿠키에도 저장 (기존 로직 유지)
    setCookie(keys.oem_name, oemValue);

    AppActions.set_oem_state(oemValue);

    // 탭 타이틀 및 파비콘 설정
    if (oemValue === 'marathon') {
      document.title = 'MARATHON AUTH';
      const favicon = document.getElementById('favicon');
      if (favicon) {
        favicon.href = logoMapper.marathon_favicon;
      }
    }
  }, []);

  return (
    <GoogleOAuthProvider clientId={GOOGLE_AUTH_CLIENT_ID}>
      <ReactNotification />
      <ScrollToTop>
        <TranslationProvider>
          <Suspense fallback={<Loader />}>
            <Core />
            <Switch>
              <Redirect exact from="/" to="login" />
              {menu}
              <AdminLayout />
              <Route path="*" to="login" />
              {/* <Route component={Error}/> */}
            </Switch>
          </Suspense>
        </TranslationProvider>
      </ScrollToTop>
    </GoogleOAuthProvider>
  );
}

export default App;
